import { IAgreementLogin } from '~/src/api/profile/serviceSettings/getAgreementLogins';
import { InferValueTypes, THydrateAction } from '~/src/store';
import { HYDRATE } from 'next-redux-wrapper';
import * as ActionCreators from '~/src/store/actionCreators/serviceSettings';
import {
    AGREEMENT_LOGIN_LOADED,
    AGREEMENT_LOGIN_LOADING,
    CONNECTION_TYPE_LOADED,
    CONNECTION_TYPE_LOADING,
    IP_PRICE_LOADED,
    IP_PRICE_LOADING,
    IP_LIST_LOADED,
    IP_LIST_LOADING,
    IPv6_STATUS_LOAD_ERROR,
    IPv6_STATUS_LOADING,
    PTR_LIST_LOADED,
    PTR_LIST_LOADING,
    IPv6_STATUS_LOADED,
    SMTP_STATE_LOAD_ERROR,
    SMTP_STATE_LOADED,
    SMTP_STATE_LOADING,
    STATISTIC_LOADING,
    STATISTIC_LOADED,
    STATISTIC_ERROR,
    MAC_LIST_LOADED,
    MAC_LIST_LOADING,
    MAC_LIST_ERROR,
} from '~/src/store/actionTypes/serviceSettings';
import { EConnectionType } from '~/src/api/profile/serviceSettings/getConnectionType';
import { ServiceSettingsIp } from '~/src/api/profile/serviceSettings/getIpList';
import { IIpPrice } from '~/src/api/profile/serviceSettings/getIpPrice';
import { IPtrZones } from '~/src/store/actions/serviceSettings';
import { EIPv6Status } from '~/src/api/profile/serviceSettings/ipv6/getIPv6Status';
import { ESmtpBlockState } from '~/src/api/profile/serviceSettings/smtp/getSmtpState';
import { IStatistic } from '~/src/api/profile/serviceSettings/statistic';

export interface IServiceSettingsState {
    agreementLogins: AgreementLoginsState,
    connectionType: IConnectionTypeState,
    ipPrice: {
        isLoading: boolean,
        ipPrice: IIpPrice
    },
    ipList: {
        isLoading: boolean,
        ipList: ServiceSettingsIp[]
    },
    ptrZones: {
        isLoading: boolean,
        ptrZones: IPtrZones
    },
    smtp: {
        isLoading: boolean,
        smtpBlockState: ESmtpBlockState | null,
    },
    ipv6: {
        isLoading: boolean,
        IPv6Status: EIPv6Status | null
    },
    statistic: {
        isLoading: boolean,
        items: IStatistic[],
    },
    macList: {
        isLoading: boolean,
        items: IStatistic[],
    },
}

interface IConnectionTypeState {
    isLoading: boolean,
    connectionType: EConnectionType
}

interface AgreementLoginsState {
    isLoading: boolean,
    agreementLogin: IAgreementLogin[]
}

const initialValue: IServiceSettingsState = {
    agreementLogins: {
        isLoading: false,
        agreementLogin: [],
    },
    connectionType: {
        isLoading: false,
        connectionType: EConnectionType.PPPoE,
    },
    ipPrice: {
        isLoading: false,
        ipPrice: {
            connect_price: '',
            discount_connect_price: '',
            discount_rent_price: '',
            rent_price: ''
        },
    },
    ipList: {
        isLoading: false,
        ipList: [],
    },
    ptrZones: {
        isLoading: false,
        ptrZones: {},
    },
    smtp: {
        isLoading: false,
        smtpBlockState: null,
    },
    ipv6: {
        isLoading: false,
        IPv6Status: null,
    },
    statistic: {
        isLoading: false,
        items: [],
    },
    macList: {
        isLoading: false,
        items: [],
    },
};
// достаем возвращаемое значения из ActionCreator
type TActions = ReturnType<InferValueTypes<typeof ActionCreators>>


export default function(state = initialValue, action: THydrateAction | TActions): IServiceSettingsState {
    switch (action.type) {
        case HYDRATE:
            return action.payload.serviceSettings;
        case AGREEMENT_LOGIN_LOADING:
            return {
                ...state,
                agreementLogins: {
                    ...state.agreementLogins,
                    isLoading: true,
                },
            };
        case AGREEMENT_LOGIN_LOADED:
            return {
                ...state,
                agreementLogins: {
                    ...state.agreementLogins,
                    isLoading: false,
                    agreementLogin: action.payload,
                },
            };
        case CONNECTION_TYPE_LOADING:
            return {
                ...state,
                connectionType: {
                    ...state.connectionType,
                    isLoading: true,
                },
            };
        case CONNECTION_TYPE_LOADED:
            return {
                ...state,
                connectionType: {
                    ...state.connectionType,
                    isLoading: false,
                    connectionType: action.payload,
                },
            };
        case IP_PRICE_LOADING:
            return {
                ...state,
                ipPrice: {
                    ...state.ipPrice,
                    isLoading: true,
                },
            };
        case IP_PRICE_LOADED:
            return {
                ...state,
                ipPrice: {
                    ...state.ipPrice,
                    isLoading: false,
                    ipPrice: action.payload,
                },
            };
        case IP_LIST_LOADING:
            return {
                ...state,
                ipList: {
                    ...state.ipList,
                    isLoading: true,
                },
            };
        case IP_LIST_LOADED:
            return {
                ...state,
                ipList: {
                    ...state.ipList,
                    isLoading: false,
                    ipList: action.payload,
                },
            };
        case PTR_LIST_LOADING:
            return {
                ...state,
                ptrZones: {
                    ...state.ptrZones,
                    isLoading: true,
                },
            };
        case PTR_LIST_LOADED:
            return {
                ...state,
                ptrZones: {
                    ...state.ptrZones,
                    isLoading: false,
                    ptrZones: action.payload,
                },
            };
        case IPv6_STATUS_LOADING:
            return {
                ...state,
                ipv6: {
                    ...state.ipv6,
                    isLoading: true,
                },
            };
        case IPv6_STATUS_LOAD_ERROR:
            return {
                ...state,
                ipv6: {
                    ...state.ipv6,
                    isLoading: false,
                    IPv6Status: EIPv6Status.error,
                },
            };
        case IPv6_STATUS_LOADED:
            return {
                ...state,
                ipv6: {
                    ...state.ipv6,
                    isLoading: false,
                    IPv6Status: action.payload,
                },
            };
        case SMTP_STATE_LOADING:
        case SMTP_STATE_LOAD_ERROR:
            return {
                ...state,
                smtp: {
                    ...state.smtp,
                    isLoading: true,
                },
            };
        case SMTP_STATE_LOADED:
            return {
                ...state,
                smtp: {
                    ...state.smtp,
                    isLoading: false,
                    smtpBlockState: action.payload,
                },
            };
        case STATISTIC_LOADING:
            return {
                ...state,
                statistic: {
                    ...state.statistic,
                    isLoading: true,
                },
            };
        case STATISTIC_ERROR:
            return {
                ...state,
                statistic: {
                    ...state.statistic,
                    isLoading: false,
                    items: [],
                },
            };
        case STATISTIC_LOADED:
            return {
                ...state,
                statistic: {
                    ...state.statistic,
                    isLoading: false,
                    items: action.payload,
                },
            };
        case MAC_LIST_LOADING:
            return {
                ...state,
                macList: {
                    ...state.macList,
                    isLoading: true,
                },
            };
        case MAC_LIST_LOADED:
            return {
                ...state,
                macList: {
                    ...state.macList,
                    isLoading: false,
                    items: action.payload,
                },
            };
        case MAC_LIST_ERROR:
            return {
                ...state,
                statistic: {
                    ...state.macList,
                    isLoading: false,
                    items: [],
                },
            };
        default:
            return state;
    }
}
